// extracted by mini-css-extract-plugin
export var cartIcon = "_oc-0";
export var cartIconContainer = "_oc-1";